import { render, staticRenderFns } from "./dialog-slot.vue?vue&type=template&id=667443b8&scoped=true"
import script from "./dialog-slot.vue?vue&type=script&lang=js"
export * from "./dialog-slot.vue?vue&type=script&lang=js"
import style0 from "./dialog-slot.vue?vue&type=style&index=0&id=667443b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667443b8",
  null
  
)

export default component.exports